import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    authorUuid: String,
    frameId: String
  }

  async copyLink(event) {
    event.preventDefault()
    event.stopPropagation()

    try {
      await navigator.clipboard.writeText(this.urlValue)
      this.showToast("Ссылка на комментарий скопирована")
    } catch (err) {
      console.error("Не удалось скопировать ссылку: ", err)
      this.showToast("Не удалось скопировать ссылку автоматически")
    }
  }

  showToast(message) {
    const toast = document.createElement("div")
    toast.className = "fixed bottom-5 right-5 bg-slate-800 text-white text-sm font-medium px-3 py-2 rounded-lg shadow-xl z-50 animate-fade-in"
    toast.innerText = message
    document.body.appendChild(toast)

    setTimeout(() => {
      toast.classList.add("opacity-0", "transition-opacity", "duration-350")
      setTimeout(() => toast.remove(), 350)
    }, 2000)
  }

  reply(event) {
    event.preventDefault()
    event.stopPropagation()

    const targetFrame = document.getElementById(this.frameIdValue)

    if (!targetFrame) {
      console.error(`Turbo Frame с ID "${this.frameIdValue}" не найден на странице!`)
      return
    }

    const editorElement = targetFrame.querySelector('.tiptap')
    const editor = editorElement?.editor

    if (!editor) {
      console.error("Tiptap редактор не найден внутри указанного Turbo Frame!")
      return
    }

    editor.chain()
      .focus()
      .insertContent([
        {
          type: 'mention',
          attrs: {
            uuid: this.authorUuidValue,
            id: this.authorUuidValue,
            label: ""
          }
        },
        {
          type: 'text',
          text: ', '
        }
      ])
      .run()
  }
}
